import React from "react";
import { IconButton, Input } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu"; 
import PropTypes from "prop-types";

const Search = ({value, handleInputChange, endAdornment}) => {
  return (
      <div className="w-full md:max-w-[420px] h-[40px] border border-gray-200 p-0.5 rounded-md">
            <Input
                placeholder="Search"
                value={value}
                onChange={handleInputChange}
                fullWidth
                disableUnderline
                startAdornment={
                    <SearchIcon color="primary" />
                }
                endAdornment={
                   endAdornment ? (
                    <IconButton edge="start" color="primary" aria-label="menu" style={{marginLeft: '4px'}}>
                        <MenuIcon />
                    </IconButton>) : (null)
                }
            />
      </div>
  );
};

Search.propTypes = {
    value: PropTypes.any,
    handleInputChange:PropTypes.func,
    endAdornment: PropTypes.bool
}

Search.defaultProps = {
    value: null,
    handleInputChange: null,
    endAdornment: false
}

export default Search;